module.exports = __webpack_public_path__ + "media/images/roku/TV4-351958bd843f7b3ab1f8c24576a8ecf9.png";